import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  remove(e) {
    e?.preventDefault()
    this.element.remove()
  }
}
